import { useEffect } from 'react'

const IDLE_MS = 2000

/**
 * Hides the mouse pointer on the projector after it has been still for two
 * seconds, as presentation software does; any movement brings it back.
 */
export const useIdleCursor = (enabled: boolean): void => {
	useEffect(() => {
		if (!enabled) {
			return
		}
		const root = document.documentElement
		let timer: number | undefined
		const hide = (): void => {
			root.style.cursor = 'none'
		}
		const wake = (): void => {
			root.style.cursor = ''
			window.clearTimeout(timer)
			timer = window.setTimeout(hide, IDLE_MS)
		}
		wake()
		window.addEventListener('mousemove', wake)
		return () => {
			window.clearTimeout(timer)
			window.removeEventListener('mousemove', wake)
			root.style.cursor = ''
		}
	}, [enabled])
}
